import React, { useContext, useEffect } from 'react'
import { useOutlet, useLocation } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion/dist/framer-motion'

import { DataContext } from './Context/DataContext'
import { UIContext } from './Context/UIContext'

import Header from './components/Header'
import Footer from './components/Footer'

const Root = () => {
    const { sectionsData } = useContext(DataContext)
    const { setCurrentPage, setShowIntroLogo } = useContext(UIContext)
    const { pathname } = useLocation()
    const outlet = useOutlet()

    useEffect(() => {
        if (!sectionsData || sectionsData.length === 0) return

        if (pathname === '/') {
            setCurrentPage('home')
        } else {
            setShowIntroLogo(false)
            const currentSection = sectionsData.find(section => section.slug === pathname)
            if (currentSection) {
                setCurrentPage(currentSection.identifier)
            } else {
                setCurrentPage('not-found')
            }
        }
    }, [sectionsData, setCurrentPage, setShowIntroLogo, pathname])

    return (
        <>
            <Header />
            <AnimatePresence
                mode="wait"
                onExitComplete={() => {
                if (typeof window !== 'undefined') {
                    window.scrollTo({ top: 0, behavior: 'instant' });
                }
            }}>
                {outlet && React.cloneElement(outlet, { key: pathname })}
            </AnimatePresence>
            <Footer />
        </>
    )
}

export default React.memo(Root)